import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044f1ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "filter"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 3,
  class: "explanation"
}
const _hoisted_4 = {
  key: 0,
  class: "navigation"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "home", -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

import { onMounted, ref, computed, nextTick } from 'vue';
import { useRoute } from 'vue-router';

import Detail from '@/components/Content/Detail.vue';
import LeaveMelati from '@/components/Content/LeaveMelati.vue';

import { indexService } from '@/services';
import { Index, IndexType } from '@functions/model/firestore';
import router, { RouteName } from '@/router';
import { getRandomCharacter } from '@/utils/string';


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  async setup(__props) {

let __temp: any, __restore: any

const PAGE_SIZE = 10;

const loading = ref(false);
const results = ref<Index[]>([]);
const currentCoverIndex = ref(0);
const wrapper = ref<HTMLElement | undefined>(undefined);
const coverTops = ref<number[]>([]);
const showNavigation = ref(true);

const route = useRoute();
const randomFilter = getRandomCharacter();

let intersectionObserver: IntersectionObserver | undefined;
let coverElements: NodeList | undefined;
let queryOptions = {};
let hasMoreResults = true;
let nextResultsCursor: string | undefined;
let filterDesc = false;

const getFirstResult = async () => {
  loading.value = true;
  const defaultQueryOptions = {
    filter: randomFilter,
    filterDesc,
    limit: PAGE_SIZE
  };

  let firstResult;
  // Route contains id of index and that content should be the first result
  // Case: opening a specific content point from the melati or deeplink
  if (route.params.id && typeof route.params.id === 'string') {
    firstResult = await indexService.getIndexById(route.params.id);
    queryOptions = {
      ...defaultQueryOptions,
      type: firstResult?.type,
      exclude: route.params.id
    };
    // Query string contains a tag for which the first result should be the tag itself and related results contain the tag
    // Case: search menu quick link by tag
  } else if (route.query.tag && typeof route.query.tag === 'string') {
    firstResult = await indexService.getIndexById(route.query.tag);
    queryOptions = {
      ...defaultQueryOptions,
      tagIds: [route.query.tag],
      exclude: route.query.tag
    };
  }

  results.value = firstResult ? [firstResult] : [];
};

const getNextQueryResult = async (options?: {}) => {
  loading.value = true;
  const { items, nextCursor } = await indexService.query(options || { ...queryOptions, cursor: nextResultsCursor });

  nextResultsCursor = nextCursor;
  results.value.push(...items);

  await nextTick();

  coverElements = wrapper.value?.querySelectorAll('[data-cover]');
  sizeChanged();

  // No new results
  if (!nextCursor) {
    // Change filter sorting direction to get the other results as well
    if (!filterDesc) {
      filterDesc = true;
      queryOptions = { ...queryOptions, filterDesc, cursor: undefined };
      await getNextQueryResult(queryOptions);
    } else {
      // All results from the query are fetched
      hasMoreResults = false;
    }
  }

  loading.value = false;
};

onMounted(async () => {
  window.addEventListener('resize', sizeChanged);

  intersectionObserver = new window.IntersectionObserver(onCoverEntry, {
    threshold: 0.9
  });

  await getNextQueryResult();
});

const sizeChanged = () => {
  coverTops.value = [];
  prepareForObservation();
};

const prepareForObservation = () => {
  coverElements?.forEach(element => {
    if (element instanceof HTMLElement && intersectionObserver) {
      intersectionObserver.observe(element);
      coverTops.value.push(element.offsetTop);
    }
  });
};

const showLeaveMelati = computed(() => {
  return firstResult?.value?.type === IndexType.Message;
});

const readMoreText = computed(() => {
  if (!route.params.id || typeof route.params.id !== 'string') return '';
  if (firstResult?.value?.type === IndexType.Story) return 'Meer verhalen';
  if (firstResult?.value?.type === IndexType.Message) return "Meer melati's";
  if (firstResult?.value?.type === IndexType.Tag) return "Meer thema's";
  return '';
});
const isFromFilter = computed(() => route.query.tag);
const firstResult = computed(() => (results.value.length > 0 ? results.value[0] : null));
const relatedResults = computed(() => results.value.slice(1));

const goToHome = () => {
  router.push({ name: RouteName.Home });
};

const hasPreviousCover = computed(() => currentCoverIndex.value > 0);
const hasNextCover = computed(() => currentCoverIndex.value < coverTops.value.length - 1);

const previousCover = () => {
  currentCoverIndex.value > 0 ? currentCoverIndex.value-- : 0;
  scrollTo({ left: 0, top: coverTops.value[currentCoverIndex.value], behavior: 'smooth' });
};

const nextCover = () => {
  currentCoverIndex.value < relatedResults.value.length ? currentCoverIndex.value++ : 0;
  scrollTo({ left: 0, top: coverTops.value[currentCoverIndex.value], behavior: 'smooth' });
};

const onCoverEntry = (entries: IntersectionObserverEntry[]) => {
  entries.forEach(entry => {
    if (!intersectionObserver) return;
    const intersecting = entry.isIntersecting !== undefined ? entry.isIntersecting : entry.intersectionRatio > 0;

    if (entry.target instanceof HTMLElement && intersecting) {
      const index = coverTops.value.indexOf(entry.target.offsetTop);

      if (index > -1) currentCoverIndex.value = index;

      if (index >= results.value.length - 2 && hasMoreResults && !loading.value) {
        getNextQueryResult();
      }
    }
  });
};

;(
  ([__temp,__restore] = _withAsyncContext(() => getFirstResult())),
  await __temp,
  __restore()
);
window.scrollTo(0, 0);

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "overview",
      ref_key: "wrapper",
      ref: wrapper
    }, [
      (_unref(isFromFilter))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, [
              _createTextVNode(" Filter: "),
              (_unref(firstResult))
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(firstResult).title), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(firstResult))
        ? (_openBlock(), _createBlock(Detail, {
            key: 1,
            index: _unref(firstResult),
            initOpen: !_unref(isFromFilter),
            first: "",
            "data-cover": "",
            onOpenDetail: sizeChanged
          }, null, 8, ["index", "initOpen"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Loader, {
        loading: !_unref(firstResult)
      }, null, 8, ["loading"]),
      (_unref(showLeaveMelati) && _unref(firstResult))
        ? (_openBlock(), _createBlock(LeaveMelati, { key: 2 }))
        : _createCommentVNode("", true),
      (_unref(relatedResults) && _unref(relatedResults).length > 0 && _unref(readMoreText))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_unref(readMoreText)), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relatedResults), (result) => {
        return (_openBlock(), _createBlock(Detail, {
          key: result.id,
          index: result,
          "data-cover": "",
          onOpenDetail: sizeChanged
        }, null, 8, ["index"]))
      }), 128))
    ], 512),
    _createVNode(_Transition, { name: "quick-fade" }, {
      default: _withCtx(() => [
        (showNavigation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "close",
                onClick: goToHome,
                "aria-label": "Terug naar de homepagina"
              }, [
                _hoisted_5,
                _createVNode(_component_Icon, { name: "close" })
              ]),
              _createElementVNode("button", {
                onClick: previousCover,
                disabled: !_unref(hasPreviousCover),
                "aria-label": "Scroll naar vorige cover"
              }, [
                _createVNode(_component_Icon, { name: "up" })
              ], 8, _hoisted_6),
              _createElementVNode("button", {
                onClick: nextCover,
                disabled: !_unref(hasNextCover),
                "aria-label": "Scroll naar volgende cover"
              }, [
                _createVNode(_component_Icon, { name: "down" })
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})